/* One row of a grade's rate history (Settings → rate card → clock icon).
   RATE HISTORY VOID (owner 26-Oct-2026): a row voided by the Founder (void: true) stays listed — never removed — with its date
   and rates struck through and "Void - <reason>" (EN + AR) under the date. What a void row means for a rate lives in the
   backend (billing_rate_backfill.rate_on); this row only shows it. */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { fmtDateTimeFirm } from "@/lib/dt";
import { fmtNumber } from "@/components/Amount";   // STEP 3 · rule 2 · B-2e: the one amount formatter

const money = (v) => fmtNumber(Number(v));

export default function RateHistoryRow({ h }) {
  const { t } = useI18n();
  const isVoid = h.void === true;
  const struck = isVoid ? "line-through" : "";
  const delta = h.old_rate == null ? null : (h.new_rate - h.old_rate);
  return (
    <tr className={`border-b ${isVoid ? "text-muted-foreground" : ""}`} data-testid={`ratecard-history-row-${h.id}`}>
      <td className="px-3 py-2 text-xs"><span className={struck}>{fmtDateTimeFirm(h.changed_at)}</span>
        {isVoid && <div className="text-[11px] text-red-700" data-testid={`ratecard-history-void-${h.id}`}>{t("rhv.voidLabel").replace("{reason}", h.void_reason || "")}</div>}
      </td>
      <td className="px-3 py-2 text-xs">{h.changed_by_name || "—"}</td>
      <td className={`px-3 py-2 num-cell ${struck}`}>{h.old_rate == null ? <span className="text-muted-foreground">initial</span> : money(h.old_rate)}</td>
      <td className={`px-3 py-2 num-cell font-medium ${struck}`} data-testid={`ratecard-history-new-${h.id}`}>{money(h.new_rate)}</td>
      <td className={`px-3 py-2 num-cell text-xs ${struck} ${delta == null ? "" : delta > 0 ? "text-emerald-600" : delta < 0 ? "text-red-600" : ""}`}>
        {delta == null ? "—" : (delta > 0 ? "+" : "") + delta.toFixed(2)}
      </td>
    </tr>
  );
}
